import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'ctep-core-layout',
    imports: [CommonModule, RouterModule],
    templateUrl: './ctep-layout.component.html',
    styleUrl: './ctep-layout.component.scss'
})
export class CtepLayoutComponent {}
